import ResourceLinkModelBase from '../_generated/modelBases/resource-link-model-base';

export default class ResourceLinkModel extends ResourceLinkModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
